export default "/renzoETH.d8081cb7653e095583a509505aa1b5ca.svg";